"use client";

import type { ReactNode } from "react";
import { createContext, useContext } from "react";

interface ConfigContentValues {
  csrfToken: string;
}

const ConfigContext = createContext<ConfigContentValues>({
  csrfToken: "missing",
});

interface ConfigProviderProps {
  children: ReactNode | ReactNode[];
  csrfToken: string;
}

export function useConfigContext() {
  return useContext(ConfigContext);
}

export function ConfigProvider({ children, csrfToken }: ConfigProviderProps) {
  return (
    <ConfigContext.Provider
      value={{
        csrfToken,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}
